var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HasPermission',{attrs:{"permission":_vm.Permissions.PackagesRead}},[_c('div',[_c('list-layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('package-table')]},proxy:true}])})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }